var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Default',{attrs:{"expandFooter":_vm.expandFooter},on:{"expandFooter":_vm.onExpandFooter}})
}
var staticRenderFns = []

export { render, staticRenderFns }